// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cwuqmrrfvwddicutkrcc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN3dXFtcnJmdndkZGljdXRrcmNjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU0Mzc3OTEsImV4cCI6MjA2MTAxMzc5MX0.vnTSavxVDynyiZSltuaWBMuIKXLK_ZHCvBpHnz07R9Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);